export default "__VITE_ASSET__DtdFqAkA__"